// Select all figcaption elements with a previous sibling of class "video__type__youtube-short"
const figcaptions = document.querySelectorAll<HTMLElement>(
  ".video__type__youtube-short + figcaption"
);

// Function to set the width of figcaption elements to match their previous sibling's width
const setFigcaptionWidth = () => {
  figcaptions.forEach((figcaption: HTMLElement) => {
    const previousSibling = figcaption.previousElementSibling as HTMLElement;
    figcaption.style.width = `${previousSibling.offsetWidth}px`;
  });
};

// Call the function initially
setFigcaptionWidth();

// Add event listener for the resize event
window.addEventListener("resize", setFigcaptionWidth);
